module.exports = __webpack_public_path__ + "img/17.b66360ea.jpg";